export const SOUTH_AFRICA_MAP_VIEW = {
  center: [24.6727, -28.4793],
  zoom: 4.5,
};

const ROAD_TILE_URL =
  process.env.REACT_APP_MAP_TILE_URL ||
  "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

export const SOUTH_AFRICA_ROAD_STYLE = {
  version: 8,
  sources: {
    "south-africa-roads": {
      type: "raster",
      tiles: [ROAD_TILE_URL],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 19,
      attribution:
        '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    },
  },
  layers: [
    {
      id: "south-africa-road-map",
      type: "raster",
      source: "south-africa-roads",
      minzoom: 0,
      maxzoom: 20,
    },
  ],
};

export function getMappableItems(items, getCoordinates) {
  return (items ?? [])
    .map((item) => {
      const coordinates = getCoordinates(item);
      const longitude = Number(coordinates?.lng);
      const latitude = Number(coordinates?.lat);

      if (
        !Number.isFinite(longitude) ||
        !Number.isFinite(latitude) ||
        longitude < -180 ||
        longitude > 180 ||
        latitude < -90 ||
        latitude > 90
      ) {
        return null;
      }

      return { item, coordinates: [longitude, latitude] };
    })
    .filter(Boolean);
}
